module.exports = __webpack_public_path__ + "static/media/download.c5590569.svg";